import React from "react";
import { useLang } from "@/i18n/LanguageContext";
import { MessageCircle } from "lucide-react";

export default function FloatingWhatsApp() {
  const { t } = useLang();
  const url = `https://api.whatsapp.com/send?phone=554599744439&text=${encodeURIComponent(
    t.whatsapp_msg
  )}`;
  return (
    <a
      href={url}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="WhatsApp"
      data-testid="floating-whatsapp"
      className="sap-whats"
    >
      <MessageCircle size={26} strokeWidth={1.75} />
    </a>
  );
}
